import Ellipsis, { EllipsisContainer } from '../Ellipsis/Ellipsis';

import { CreditCardData } from '@types-internal';

export type CreditCardNumberProps = {
  lastFourDigits?: CreditCardData['lastFourDigits'];
  theme?: 'dark' | 'default';
};

/**
 * Display 16 dots which stands for the credit card number.
 * If lastFourDigits is a non-empty string, display 12 dots + these lastFourDigits.
 */
const MaskedCreditCardNumber: React.FC<CreditCardNumberProps> = ({ theme, lastFourDigits }) => {
  return (
    <EllipsisContainer theme={theme}>
      <Ellipsis identifier="firstFour" />
      <Ellipsis identifier="secondFour" />
      <Ellipsis identifier="thirdFour" />
      <span className="lastFourDigits">
        {lastFourDigits || <Ellipsis identifier="fourthFour" />}
      </span>
    </EllipsisContainer>
  );
};

export default MaskedCreditCardNumber;
